import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';

import './nvstyle.css';

function MainMenu( props ) {
    const [ path, setPath ] = useState( "" );
    const REACT_APP_PUBLIC_URL = "/react/molla";
    let brands = props.brands;
    
    useEffect( () => {
        setPath( window.location.href );
    } )

    function showAllDemos( e ) {
        let demoItems = document.querySelectorAll( '.demo-item.hidden' );

        for ( let i = 0; i < demoItems.length; i++ ) {
            demoItems[ i ].classList.toggle( 'show' );
        }

        document.querySelector( '.view-all-demos' ).classList.toggle( 'disabled-hidden' );
        e.preventDefault();
    }

    return (
        <nav className="main-nav" >
            <ul className="menu sf-arrows">
                
                <li className={ `megamenu-container` } id="menu-home">
                    <Link to={ `${process.env.REACT_APP_PUBLIC_URL}` } >Accueil</Link>
                </li>
                

                <li className={  '' }>
                    <Link to={ `${process.env.REACT_APP_PUBLIC_URL}/shop/sidebar/list` } >Boutique</Link>
                </li>

                <li className={ path.indexOf( "/brand" ) > -1 ? 'active' : '' }>
                    <span  className="sf-with-ul" id="navspan" >Marques</span>

                    <ul className="scroller marques"
                     style={{ overflowY: 'scroll', maxHeight: '650px', direction: 'rtl', scrollbarWidth: 'thin !important'}}>


                        {
                            brands.map( ( item, index ) =>
                            <div className="filter-item" key={ `cat_${index}` }>
                                <span/>
                                <li className={ path.indexOf( "blog/classic" ) > -1 ? 'active' : '' }>
                                    <Link to={ `${process.env.REACT_APP_PUBLIC_URL}/shop/bybrand/${item.slug}` }> {item.nameFr}</Link>
                                </li>
                            </div>
                        )
                        }
                        
                      
                    </ul>
                </li>

                {/*<li className={ path.indexOf( "product/" ) > -1 ? 'active' : '' }>
                    <Link to={ `${process.env.REACT_APP_PUBLIC_URL}/product/default/7` } >Product</Link>
                </li>
                
                path.indexOf( "pages/about" ) > -1 ? 'active' : 
                path.indexOf( "pages/contact" ) > -1 ? 'active' :  
                 path.indexOf( "pages/faq" ) > -1 ? 'active' :             */}

                <li className={ '' }>
                    <Link to={ `${process.env.REACT_APP_PUBLIC_URL}/pages/about` }>À propos</Link>
                </li>

                <li className={ '' }>
                    <Link to={ `${process.env.REACT_APP_PUBLIC_URL}/pages/contact` }>Contact</Link>
                </li>

                {/*<li className={ '' }>
                    <Link to={ `${process.env.REACT_APP_PUBLIC_URL}/pages/faq` }>FAQs</Link>
                </li>*/}
                
            </ul>
        </nav>
    );
}


function mapStateToProps( state ) {
    return {
        brands: state.brands.brands ? state.brands.brands : [],
    }
}

export default connect( mapStateToProps, null ) (MainMenu);